export type CardState = "frozen" | "cancelled" | "expired" | null;

const statusOf = (card?: Card) =>
  card?.subscription?.status?.toLowerCase() ?? "";

export const isSubscriptionCancelled = (card?: Card) =>
  ["cancelled", "canceled"].includes(statusOf(card));

export const isSubscriptionExpired = (card?: Card) =>
  statusOf(card) === "expired";

// Frozen wins when a card is also cancelled or expired.
export const getCardState = (card?: Card): CardState =>
  card?.status === "Frozen"
    ? "frozen"
    : isSubscriptionCancelled(card)
      ? "cancelled"
      : isSubscriptionExpired(card)
        ? "expired"
        : null;
